import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import {
  LINE_ITEM_BREAKFAST,
  LINE_ITEM_DAY,
  LINE_ITEM_FIXED,
  LINE_ITEM_NIGHT,
  propTypes,
} from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * A component that renders the base price as a line item.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {propTypes.lineItemUnitType} props.code - The code of the line item
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */

const LineItemBreakfastMaybe = props => {
  const { lineItems, priceVariantDays, code, intl, listingType } = props;

  const isStayListingType = code === LINE_ITEM_NIGHT;
  const isMultiDayListingType = code === LINE_ITEM_DAY;
  const isFixedListingType = code === LINE_ITEM_FIXED;

  const breakfastLineItem = lineItems?.find(
    item => item.code === LINE_ITEM_BREAKFAST && !item.reversal
  );

  if (!breakfastLineItem) return;

  const translationKey = 'OrderBreakdown.breakfast';

  // Find correct line-item for given code prop.
  // It should be one of the following: 'line-item/night, 'line-item/day', 'line-item/hour', or 'line-item/item'
  // These are defined in '../../util/types';
  const unitPurchase = breakfastLineItem;

  const quantity = unitPurchase?.units
    ? unitPurchase.units.toString()
    : unitPurchase?.quantity
    ? unitPurchase.quantity.toString()
    : null;

  const unitPrice = unitPurchase ? formatMoney(intl, unitPurchase.unitPrice) : null;
  const total = unitPurchase ? formatMoney(intl, unitPurchase.lineTotal) : null;

  const message = isMultiDayListingType ? (
    <FormattedMessage
      id="OrderBreakdown.multiDayBreakfast"
      values={{ unitPrice, quantity: +quantity }}
    />
  ) : isFixedListingType && listingType === 'listingtype-exp-shared-fixed' ? (
    <FormattedMessage
      id="OrderBreakdown.fixedBreakfast"
      values={{ unitPrice, quantity: +quantity }}
    />
  ) : !isStayListingType ? (
    <FormattedMessage id="OrderBreakdown.oneBreakfast" />
  ) : (
    <FormattedMessage id={translationKey} values={{ unitPrice, quantity: +quantity }} />
  );

  return quantity && total ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>{message}</span>
      <span className={css.itemValue}>{total}</span>
    </div>
  ) : null;
};

export default LineItemBreakfastMaybe;
